import Store from "../../../../Store/Store";

class ReportTypeContainer {
  public pickIdFromLabel(label) {
    const reportTypes = Store.getConfigurator().getState().globalTypes?.ReportType;

    if (!reportTypes) {
      return;
    }

    for(const type in reportTypes) {
      if (reportTypes[type].label?.toLowerCase() === label?.toLowerCase()) {
        return reportTypes[type].id
      }
    }
  }
}

export default new ReportTypeContainer();
